import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ActivatedRoute, Params} from '@angular/router';
import {ThemeChangerService} from '../../service/theme-change.service';

@Component({
  selector: 'app-mini-pricer-iframe',
  templateUrl: './mini-pricer-iframe.component.html',
  styleUrls: ['./mini-pricer-iframe.component.scss']
})
export class MiniPricerIframeComponent implements OnInit {

  @Input() graphColor = '5,121,162';
  @Input() refId;

  @Output() closeDialog: EventEmitter<any> = new EventEmitter();

  mode = 'SEARCH';

  loanPurpose: string;
  propertyUse: string;
  propertyType: string;
  preferredAmortization: string;
  fico: number;
  zip: string;
  homeValue: number;
  amount: number;
  lockDays: number;
  secondLoanOption: boolean;
  escrowWaiver: boolean;
  secondLoanAmount: number;
  showVA: boolean;
  unit: number;
  computePropertyTax: boolean;

  title = 'Find a loan';
  searchLabel = 'See My Options';

  constructor(public bsModalRef: BsModalRef, private activatedRoute: ActivatedRoute, protected themeChangerService: ThemeChangerService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.refId = params.refId;
      if (params.graphColor) {
        this.graphColor = params.graphColor;
      }

      this.loanPurpose = params.loanPurpose ? params.loanPurpose : null;
      this.propertyUse = params.propertyUse ? params.propertyUse : null;
      this.propertyType = params.propertyType ? params.propertyType : null;
      this.preferredAmortization = params.preferredAmortization ? params.preferredAmortization : null;
      this.fico = params.fico ? parseInt(params.fico, 10) : null;
      this.zip = params.zip ? params.zip : null;
      this.homeValue = params.homeValue ? parseInt(params.homeValue, 10) : null;
      this.amount = params.amount ? parseInt(params.amount, 10) : null;
      this.lockDays = params.lockDays ? parseInt(params.lockDays, 10) : null;
      this.secondLoanOption =  params.secondLoanOption === 'true' ? true : (params.secondLoanOption === 'false' ? false : null);
      this.escrowWaiver =  params.escrowWaiver === 'true' ? true : (params.escrowWaiver === 'false' ? false : null);
      this.secondLoanAmount = params.secondLoanAmount ? parseInt(params.secondLoanAmount, 10) : null;
      this.showVA = params.showVA === 'true' ? true : (params.showVA === 'false' ? false : null);
      this.unit = params.unit ? parseInt(params.unit, 10) : null;
      this.computePropertyTax = params.computePropertyTax === 'true' ? true : (params.computePropertyTax === 'false' ? false : null);
      this.title = params.title ? params.title : this.title;
      this.searchLabel = params.searchLabel ? params.searchLabel : this.searchLabel;

      const primary = params.primary ? params.primary : '';
      const secondary = params.secondary ? params.secondary : '';
      const success = params.success ? params.success : '';
      const info = params.info ? params.info : '';
      const warning = params.warning ? params.warning : '';
      const danger = params.danger ? params.danger : '';
      const light = params.light ? params.light : '';
      const dark = params.dark ? params.dark : '';
      const bgColor = params.bgColor ? params.bgColor : '';

      this.themeChangerService.changeTheme(
        primary,
        secondary,
        success,
        info,
        warning,
        danger,
        light,
        dark,
        bgColor
      );
    });
  }

  ngOnInit(): void {
  }


  modeOut($event: any) {
    this.mode = $event;
  }

  close() {
    this.bsModalRef.hide();
    this.closeDialog.emit();
    this.closeIframe();
  }

  closeIframe() {
    window.parent.postMessage(
      {
        action: 'close'
      },
      '*');
  }
}
